// 导出页面为PDF格式
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'

export default (dom, title) => {
  if (dom && JsPDF && html2Canvas) {
    title = title || ''
    return new Promise((reslove, reject) => {
      html2Canvas(dom, {
        allowTaint: true,
        taintTest: false,
        useCORS: true,
        backgroundColor: 'white',
        y: 0, // 对Y轴进行裁切
        // width:1200,
        // height:5000,
        dpi: window.devicePixelRatio * 2, // 将分辨率提高到特定的DPI 提高四倍
        scale: 2 // 按比例增加分辨率
      }).then(function (canvas) {
        reslove()
        var contentWidth = canvas.width
        var contentHeight = canvas.height
        var pageHeight = contentWidth / 592.28 * 841.89
        var leftHeight = contentHeight
        var position = 0
        var imgWidth = 595.28
        var imgHeight = 592.28 / contentWidth * contentHeight
        var pageData = canvas.toDataURL('image/jpeg', 1.0)
        var PDF = new JsPDF('', 'pt', 'a4')

        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
            leftHeight -= pageHeight
            position -= 841.89
            if (leftHeight > 0) {
              PDF.addPage()
            }
          }
        }
        PDF.save(title + '.pdf')
      }).catch(err => {
        reject()
      })
    })
  }
}
